import { ApiIntegrationServiceOffice } from '../api-types/integration-office.api';
import { IntegrationServiceOffice } from '../app-types/integration-office.app';
import { transformApiAddressToAppAddress } from './address.transform';
import { transformApiContactPointsToAppContactPoints } from './contact-point.transform';
import { transformApiIntegrationServicesToAppIntegrationServices } from './service.transform';

/**
 * Transforms an API Integration Service Office object to an App Integration Service Office object.
 * @param input The API Integration Service Office object to transform.
 * @returns The transformed App Integration Service Office object.
 */
export function transformApiIntegrationOfficeToAppIntegrationOffice(
	input: ApiIntegrationServiceOffice,
): IntegrationServiceOffice {
	return {
		id: input.id,
		shortName: input.shortName,
		remark: input.remark,
		initial: input.initial,
		isInclusionOffice: input.isInclusionOffice,
		fullTimeJobs: input.fullTimeJobs,
		services: transformApiIntegrationServicesToAppIntegrationServices(input.services),
		address: input.address ? transformApiAddressToAppAddress(input.address) : undefined,
		contactPoints: input.contactPoints ? transformApiContactPointsToAppContactPoints(input.contactPoints) : [],
	};
}

/**
 * Transforms an array of API Integration Service Office objects to an array of App Integration Service Office objects.
 * @param inputs The array of API Integration Service Office objects to transform.
 * @returns The array of transformed App Integration Service Office objects.
 */
export function transformApiIntegrationOfficesToAppIntegrationOffices(inputs: ApiIntegrationServiceOffice[]) {
	return inputs.map(transformApiIntegrationOfficeToAppIntegrationOffice);
}
